import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-3 py-1 text-[10.5px] font-bold uppercase tracking-[0.10em] ' +
    'transition-colors focus:outline-none focus:ring-2 focus:ring-coral/40',
  {
    variants: {
      variant: {
        default:    'bg-ink-900 text-white',
        secondary:  'bg-white dark:bg-white/10 text-ink dark:text-white ring-1 ring-ink/10 dark:ring-white/15',
        destructive:'bg-rose-500/15 text-rose-700 ring-1 ring-rose-500/30 dark:bg-rose-500/25 dark:text-rose-200 dark:ring-rose-500/40',
        outline:    'border border-ink/15 dark:border-white/15 text-ink dark:text-white',
        saffron:    'bg-coral text-white',          // legacy "saffron" → coral
        success:    'bg-lime-neon text-ink',
        warning:    'bg-coral/15 text-coral-700 ring-1 ring-coral/25 dark:bg-coral/20 dark:text-coral-200 dark:ring-coral/40',
        info:       'bg-lavender-100 text-lavender-700 ring-1 ring-lavender-200 dark:bg-lavender-400/20 dark:text-lavender-200 dark:ring-lavender-400/30',
      },
    },
    defaultVariants: { variant: 'default' },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
